import {RequestModel} from "../../../request";
import {REQUEST} from "../../../requests.consts";
import {shareState} from "../../../../../app/share-state";

export class GetRequestTournamentInfoModel extends RequestModel {
  constructor() {
    super(REQUEST.CATEGORY.tournament, REQUEST.ACTION.TOURNAMENT.info, {}, false, true, false, false);

    this.apiEnvironment = shareState.environment.baseUrl;
    this.method = REQUEST.METHOD_TYPE.get;
  }
}
